import { useGetRequest } from 'hooks/utils/useGetRequest';
import { CreatedInterfaces } from 'interfaces';
import { SearchClaimsFilters } from "../claims";
import { format } from 'date-fns';
import { IssuersBrands } from '../../../utils/IssuersBrands';
import { useAppContext } from '../../../context/appContext';
import { MastercardDisputeReasonCodes, VisaDisputeReasonCodes } from '../enums/dispute-reason.enum';

const parameterToParamMap = {
    lastFout: 'last_four',
    cuil: 'cuil',
    status: 'status',
    disputeReason: 'dispute_reason'
};

const useGetClaims = (pageIndex: number, pageSize: number, claimsFilter: SearchClaimsFilters) => {
  const resource = 'claims-paginated'
  const {
    settings: { issuer },
  } = useAppContext();

  let path = `v1/claims?size=${pageSize}&page=${pageIndex}&start_date=${format(claimsFilter.dateRanges?.[0]?.toDate(), 'yyyy-MM-dd')}T00:00:00.000&end_date=${format(claimsFilter.dateRanges?.[1]?.toDate(), 'yyyy-MM-dd')}T23:59:00.000`;

  Object.entries(claimsFilter).forEach(([param, value]) => {
    if (value && param in parameterToParamMap) {
      if(param === 'disputeReason') {
        path += `&${parameterToParamMap[param]}=${value}&reason_code=${issuer?.brand === "VISA" ? VisaDisputeReasonCodes[value as string] : MastercardDisputeReasonCodes[value as string]}`;
      } else
        path += `&${parameterToParamMap[param]}=${value}`;
    }
  });

  const [{ data, error, loading }] = useGetRequest<CreatedInterfaces<typeof resource>>({
    path,
  });

  return {
    claims: data?.data,
    pageInfo: data?.meta,
    isLoading: loading,
    isError: error,
  };
};

export default useGetClaims;
